import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import Button from '@mui/material/Button';
import { Card, Form, Radio, Modal, Input, notification, Layout, Row, Col } from 'antd';
import PageHeader from "../../components/PageHeader";
import {iconMapping} from "../../configs/AppsConfig";
import {selectUserFields} from "../../store/slices/user.slice";
import {updateUser} from "../../api/userApi";
import { unwindToDotpath } from "../../utils/tools";
import PasswordEntry from "../../components/Entries/PasswordEntry";
import {resetPassword} from "../../api/userApi";
import {LockResetRounded} from "@mui/icons-material";

const PasswordResetModal = ({ visible, onResetSuccess, onCancel }) => {
  const dispatch = useDispatch();

  const handleSuccess = (newPassword) => {
    dispatch(resetPassword({ password: newPassword }));
    onResetSuccess();
  };

  return (
    <Modal
      title="Reset Your Password"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose={true}
    >
      <PasswordEntry minCharacters={8} onSuccess={handleSuccess} />
    </Modal>
  );
};

// DisplayName Input Component
const DisplayNameInput = ({displayName}) => (
  <Form.Item
    name={['settings', 'display_name']}
    label="Display Name"
    initialValue={displayName}
    rules={[{ required: true, message: 'Please input your display name!' }]}
  >
    <Input />
  </Form.Item>
);

// Email Input Component with validation
const EmailInput = ({email}) => (
  <Form.Item
    name={['settings', 'email']}
    label="Email"
    initialValue={email}
    rules={[
      { type: 'email', message: 'The input is not a valid email!' },
      { required: true, message: 'Please input your email!' }
    ]}
  >
    <Input />
  </Form.Item>
);


const PortfolioPrefixInput = ({prefix}) => (
  <Form.Item
    name={['settings', 'portfolio_prefix']}
    label="Portfolio Prefix (Name Attached to Beginning of Portfolio Names)"
    initialValue={prefix}
  >
    <Input />
  </Form.Item>
);



const Settings = ({ onSave }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [isPasswordModalVisible, setPasswordModalVisible] = useState(false);
  const userSettings = useSelector((state) => selectUserFields(state, 'settings'));
  const handleSubmit = (values) => {
    const dotpathObject = unwindToDotpath(values);
    dispatch(updateUser({updateData: {$set: dotpathObject}}));
    notification.success({
        message: 'Settings Saved',
        description: 'Your settings have been saved successfully',
    });
  };
  const handlePasswordResetSuccess = () => {
    setPasswordModalVisible(false);
    notification.success({
      message: 'Password Reset',
      description: 'Your password has been reset successfully. Please use your new password at next login.'
    });
  };

  return (
    <Layout>
      <PageHeader title={'User Settings'} logoUrl={iconMapping.settings} />
      <Layout.Content style={{padding: '1rem'}}>
        <Row justify={'center'}>
          <Col>
            <Card title={'Account Basics'} >
              <Form form={form} layout="vertical" onFinish={handleSubmit}>
              <DisplayNameInput displayName={userSettings?.display_name}  />
              <EmailInput email={userSettings?.email} />
              <PortfolioPrefixInput
                  prefix={userSettings?.portfolio_prefix}
              />
              <Form.Item
                name={['settings', 'email_signals']}
                label="Email Signals"
                initialValue="no"
              >
                <Radio.Group>
                  <Radio.Button value="yes">Yes</Radio.Button>
                  <Radio.Button value="no">No</Radio.Button>
                </Radio.Group>
              </Form.Item>

              <Form.Item>
                <Button variant={'contained'} color={'primary'} type="submit">
                  Save Settings
                </Button>
              </Form.Item>
            </Form>
            </Card>
          </Col>
          <Col offset={1}>
            <Card bordered={true} title={'Account Actions'}>
              <Button startIcon={<LockResetRounded/>} color={'error'} onClick={()=>setPasswordModalVisible(true)}>
                Reset Password
              </Button>
            </Card>
          </Col>
        </Row>
        <div className={'content-wrapper'} style={{maxWidth: '700px', margin: 'auto'}}>
          <div className={'p-6'}>
          </div>
        </div>
        <PasswordResetModal
          visible={isPasswordModalVisible}
          onResetSuccess={handlePasswordResetSuccess}
          onCancel={() => setPasswordModalVisible(false)}
        />
      </Layout.Content>
    </Layout>
  );
};

export default Settings;

